<template>
  <v-flex
    id="solutionSummary"
    class="question"
  >
    <div class="question_filled text-dark">
      <h2
        v-if="getSolutionSummaryQuestions?.label"
        class="display-3 display-3_dark mb-4"
      >
        {{ getSolutionSummaryQuestions?.label }}
      </h2>
      <v-layout wrap>
        <v-flex xs12>
          <p class="fw-600 f-2 mb-2">
            {{ $t('sheet.sheetOne.reflection.solution_summary.resources') }}
          </p>
        </v-flex>
        <v-flex xs12>
          <ul>
            <li
              v-for="(item, index) in hasResources"
              :key="index"
            >
              {{ createResourcesText(item) }}
            </li>
          </ul>
        </v-flex>
        <v-flex xs12>
          <v-divider class="my-3" />
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12>
          <p class="fw-600 f-2 mb-2">
            {{ $t('sheet.sheetOne.reflection.solution_summary.important_barriers') }}
          </p>
        </v-flex>
        <v-flex xs12>
          <v-layout wrap>
            <v-flex
              v-if="importantCompetence.length > 0"
              md6
              class="mb-2"
            >
              <p class="fw-600 f-1 mb-2">
                {{ $t('sheet.sheetOne.reflection.solution_summary.competence') }}
              </p>
              <ul>
                <li
                  v-for="(item, index) in importantCompetence"
                  :key="index"
                >
                  {{ createText(item, 1) }}
                </li>
              </ul>
            </v-flex>
            <v-flex
              v-if="importantBeliefs.length > 0"
              md6
              class="mb-2"
            >
              <p class="fw-600 f-1 mb-2">
                {{ $t('sheet.sheetOne.reflection.solution_summary.beliefs') }}
              </p>
              <ul>
                <li
                  v-for="(item, index) in importantBeliefs"
                  :key="index"
                >
                  {{ createText(item, 2) }}
                </li>
              </ul>
            </v-flex>
            <v-flex
              v-if="importantCondition.length > 0"
              md6
            >
              <p class="fw-600 f-1 mb-2">
                {{ $t('sheet.sheetOne.reflection.solution_summary.conditions') }}
              </p>
              <ul>
                <li
                  v-for="(item, index) in importantCondition"
                  :key="index"
                >
                  {{ createText(item, 3) }}
                </li>
              </ul>
            </v-flex>
            <v-flex
              v-if="importantSupport.length > 0"
              md6
            >
              <p class="fw-600 f-1 mb-2">
                {{ $t('sheet.sheetOne.reflection.solution_summary.support') }}
              </p>
              <ul>
                <li
                  v-for="(item, index) in importantSupport"
                  :key="index"
                >
                  {{ createText(item, 4) }}
                </li>
              </ul>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-divider class="my-3" />
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12>
          <p class="fw-600 f-2 mb-2">
            {{ $t('sheet.sheetOne.reflection.solution_summary.break_barriers') }}
          </p>
        </v-flex>
        <v-flex xs12>
          <v-layout wrap>
            <v-flex
              v-if="breakCompetence.length > 0"
              md6
              class="mb-2"
            >
              <p class="fw-600 f-1 mb-2">
                {{ $t('sheet.sheetOne.reflection.solution_summary.competence') }}
              </p>
              <ul>
                <li
                  v-for="(item, index) in breakCompetence"
                  :key="index"
                >
                  {{ createText(item, 1) }}
                </li>
              </ul>
            </v-flex>
            <v-flex
              v-if="breakBeliefs.length > 0"
              md6
              class="mb-2"
            >
              <p class="fw-600 f-1 mb-2">
                {{ $t('sheet.sheetOne.reflection.solution_summary.beliefs') }}
              </p>
              <ul>
                <li
                  v-for="(item, index) in breakBeliefs"
                  :key="index"
                >
                  {{ createText(item, 2) }}
                </li>
              </ul>
            </v-flex>
            <v-flex
              v-if="breakCondition.length > 0"
              md6
            >
              <p class="fw-600 f-1 mb-2">
                {{ $t('sheet.sheetOne.reflection.solution_summary.conditions') }}
              </p>
              <ul>
                <li
                  v-for="(item, index) in breakCondition"
                  :key="index"
                >
                  {{ createText(item, 3) }}
                </li>
              </ul>
            </v-flex>
            <v-flex
              v-if="breakSupport.length > 0"
              md6
            >
              <p class="fw-600 f-1 mb-2">
                {{ $t('sheet.sheetOne.reflection.solution_summary.support') }}
              </p>
              <ul>
                <li
                  v-for="(item, index) in breakSupport"
                  :key="index"
                >
                  {{ createText(item, 4) }}
                </li>
              </ul>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-divider class="my-3" />
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12>
          <p class="fw-600 f-2 mb-2">
            {{ $t('sheet.sheetOne.reflection.solution_summary.influence_barriers') }}
          </p>
        </v-flex>
        <v-flex xs12>
          <v-layout wrap>
            <v-flex
              v-if="influencedCompetence.length > 0"
              md6
              class="mb-2"
            >
              <p class="fw-600 f-1 mb-2">
                {{ $t('sheet.sheetOne.reflection.solution_summary.competence') }}
              </p>
              <ul>
                <li
                  v-for="(item, index) in influencedCompetence"
                  :key="index"
                >
                  {{ createText(item, 1) }}
                </li>
              </ul>
            </v-flex>
            <v-flex
              v-if="influencedBeliefs.length > 0"
              md6
              class="mb-2"
            >
              <p class="fw-600 f-1 mb-2">
                {{ $t('sheet.sheetOne.reflection.solution_summary.beliefs') }}
              </p>
              <ul>
                <li
                  v-for="(item, index) in influencedBeliefs"
                  :key="index"
                >
                  {{ createText(item, 2) }}
                </li>
              </ul>
            </v-flex>
            <v-flex
              v-if="influencedCondition.length > 0"
              md6
            >
              <p class="fw-600 f-1 mb-2">
                {{ $t('sheet.sheetOne.reflection.solution_summary.conditions') }}
              </p>
              <ul>
                <li
                  v-for="(item, index) in influencedCondition"
                  :key="index"
                >
                  {{ createText(item, 3) }}
                </li>
              </ul>
            </v-flex>
            <v-flex
              v-if="influencedSupport.length > 0"
              md6
            >
              <p class="fw-600 f-1 mb-2">
                {{ $t('sheet.sheetOne.reflection.solution_summary.support') }}
              </p>
              <ul>
                <li
                  v-for="(item, index) in influencedSupport"
                  :key="index"
                >
                  {{ createText(item, 4) }}
                </li>
              </ul>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
    <div
      v-if="getSolutionSummaryQuestions?.hasOwnProperty('what_help')"
      class="mt-4"
    >
      <p
        class="fw-600 f-2"
        :class="{ required: getSolutionSummaryQuestions?.what_help?.required }"
      >
        {{ getSolutionSummaryQuestions?.what_help?.label }}
      </p>
      <v-textarea
        v-model="whatHelp"
        v-validate="{ ...regularLongText(getSolutionSummaryQuestions?.what_help?.required) }"
        :error-messages="errors.collect('reflection_summary')"
        :data-vv-as="$t('label.question')"
        :data-vv-name="'reflection_summary'"
        :required="getSolutionSummaryQuestions?.what_help?.required"
        :placeholder="$t('sheet.enter_text')"
        auto-grow
        :disabled="readOnly"
      />
    </div>
  </v-flex>
</template>

<script>
import validationRules from '@/constants/validationRules';

import { createHelpers } from 'vuex-map-fields';
import { mapGetters } from 'vuex';

import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';

const { mapFields: mapReflectionBarriersFields } = createHelpers({
    getterType: 'sheet/getReflectionBarriersField'
});

const { mapFields: mapReflectionResourcesFields } = createHelpers({
    getterType: 'sheet/getReflectionResourcesField'
});

const { mapFields: mapReflectionSolutionSummaryFields } = createHelpers({
    getterType: 'sheet/getReflectionSolutionSummaryField',
    mutationType: 'sheet/updateReflectionSolutionSummaryField'
});

export default {
    name: 'SolutionSummary',
    mixins: [sheetValidationRules],
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            validationRules
        };
    },
    computed: {
        ...mapReflectionBarriersFields([
            'importantCompetence',
            'importantBeliefs',
            'importantCondition',
            'importantSupport',
            'competenceOtherText',
            'beliefsOtherText',
            'conditionOtherText',
            'supportOtherText',
            'breakCompetence',
            'breakBeliefs',
            'breakCondition',
            'breakSupport',
            'influencedCompetence',
            'influencedBeliefs',
            'influencedCondition',
            'influencedSupport'
        ]),
        ...mapReflectionResourcesFields(['hasResources', 'otherResources']),
        ...mapReflectionSolutionSummaryFields(['whatHelp']),
        competenceBarriers () {
            return this.$store.getters['sheet/getSheetOneResource'].sheet_resource.find((el) => {
                return el.id === 25;
            }).resources;
        },
        beliefsBarriers () {
            return this.$store.getters['sheet/getSheetOneResource'].sheet_resource.find((el) => {
                return el.id === 26;
            }).resources;
        },
        conditionBarriers () {
            return this.$store.getters['sheet/getSheetOneResource'].sheet_resource.find((el) => {
                return el.id === 27;
            }).resources;
        },
        supportBarriers () {
            return this.$store.getters['sheet/getSheetOneResource'].sheet_resource.find((el) => {
                return el.id === 28;
            }).resources;
        },
        allResources () {
            return this.$store.getters['sheet/getSheetOneResource'].sheet_resource.find((el) => {
                return el.id === 24;
            }).resources;
        },
        ...mapGetters('sheet', ['getSolutionSummaryQuestions'])
    },
    methods: {
        createText (item, id) {
            if (item === 150 || item === 156 || item === 161 || item === 169) {
                switch (id) {
                case 1:
                    return this.competenceOtherText;
                case 2:
                    return this.beliefsOtherText;
                case 3:
                    return this.conditionOtherText;
                case 4:
                    return this.supportOtherText;
                }
            } else {
                switch (id) {
                case 1:
                    return this.competenceBarriers.find((el) => el.id === item).description;
                case 2:
                    return this.beliefsBarriers.find((el) => el.id === item).description;
                case 3:
                    return this.conditionBarriers.find((el) => el.id === item).description;
                case 4:
                    return this.supportBarriers.find((el) => el.id === item).description;
                }
            }
        },
        createResourcesText (item) {
            if (item === 143) {
                return this.otherResources;
            } else {
                return this.allResources.find((el) => el.id === item).description;
            }
        }
    }
};
</script>

<style scoped></style>
